import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';
import { LanguageComponent } from '@core/layout/sidebar/components/language/language.component';
import { LogoutConfirmationComponent } from '@core/layout/sidebar/components/logout-confirmation/logout-confirmation.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { ActionButtonComponent, IconNameMap } from '@kerberos-compliance/compliance-shared-ui';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'aad-sidebar-actions',
  templateUrl: './sidebar-actions.component.html',
  styleUrl: './sidebar-actions.component.less',
  imports: [NzIconModule, LanguageComponent, TranslocoDirective, ActionButtonComponent, LogoutConfirmationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarActionsComponent {
  public isCollapsed = input(false);

  protected readonly IconNameMap = IconNameMap;

  private readonly logoutConfirmation = viewChild(LogoutConfirmationComponent);

  /**
   * Asks the user to confirm before logging out.
   * The session stays untouched until they confirm; the dialog performs the logout itself.
   *
   * @returns {void} Does not return any value.
   */
  public logout(): void {
    this.logoutConfirmation()?.open();
  }
}
